export default class UserModel extends Backbone.Model {
  constructor(options) {
    super(options);
  }
}
